import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from "../plugins/axios";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        path: '/console',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/Main.vue'),
        props: true,
    },
    {
        path: '/console/dashboard',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/Dashboard.vue'),
        props: true
    },
    {
        path: '/console/blacklist',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/BlackList.vue'),
        props: true
    },
    {
        path: '/console/blacklist/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/BlackIpView.vue'),
        props: true
    },
    {
        path: '/console/blacklist/:_ip',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/BlackIpView.vue'),
        props: true
    },
    {
        path: '/console/whitelist',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/WhiteList.vue'),
        props: true
    },  
    {
        path: '/console/whitelist/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/WhiteIpView.vue'),
        props: true
    },
    {
        path: '/console/whitelist/:_ip',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/WhiteIpView.vue'),
        props: true
    },
    {
        path: '/console/cp/whitelist',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/CpWhiteList.vue'),
        props: true
    },  
    {
        path: '/console/cp/whitelist/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/CpWhiteIpView.vue'),
        props: true
    },
    {
        path: '/console/cp/whitelist/:_ip',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/ip/CpWhiteIpView.vue'),
        props: true
    },
    {
        path: '/console/admins',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/admin/AdminList.vue'),
        props: true
    },
    {
        path: '/console/admins/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/admin/AdminView.vue'),
        props: true
    },
    {
        path: '/console/admins/:_admin',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/admin/AdminView.vue'),
        props: true
    },
    {
        path: '/console/auth',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/auth/AuthList.vue'),
        props: true
    },
    {
        path: '/console/common/partners',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/partner/PartnerList.vue'),
        props: true
    },
    {
        path: '/console/user/ebook-companies',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/EBookCompanies.vue'),
        props: true
    },
    {
        path: '/console/members',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/MemberList.vue'),
        props: true
    },
    {
        path: '/console/members/:_member',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/MemberView.vue'),
        props: true
    },
    {
        path: '/console/member/withdrawals',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/WithdrawalList.vue'),
        props: true
    },
    {
        path: '/console/points',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/PointList.vue'),
        props: true
    },
    {
        path: '/console/member/levels',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/member/LevelList.vue'),
        props: true
    },
    {
        path: '/console/member/levels/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/member/LevelView.vue'),
        props: true
    },
    {
        path: '/console/member/levels/:_level',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/member/LevelView.vue'),
        props: true
    },
    {
        path: '/console/terms',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/TermsList.vue'),
        props: true
    },
    {
        path: '/console/terms/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/TermsView.vue'),
        props: true
    },
    {
        path: '/console/terms/:_terms',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/user/TermsView.vue'),
        props: true
    },
    {
        path: '/console/board/configs',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/board/ConfigList.vue'),
        props: true
    },
    {
        path: '/console/board/configs/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/board/ConfigView.vue'),
        props: true
    },
    {
        path: '/console/board/configs/:_config',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/board/ConfigView.vue'),
        props: true
    },
    {
        path: '/console/boards/comment',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/board/comment/CommentList.vue'),
        props: true
    },
    {
        path: '/console/boards/event',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/board/event/List.vue'),
        props: true
    },
    {
        path: '/console/boards/event/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/board/event/View.vue'),
        props: true
    },
    {
        path: '/console/boards/event/:_board',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/board/event/View.vue'),
        props: true
    },
    {
        path: '/console/boards',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/board/BoardList.vue'),
        props: true
    },
    {
        path: '/console/boards/:_board',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/board/BoardView.vue'),
        props: true
    },
    {
        path: '/console/form/configs',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/form/ConfigList.vue'),
        props: true
    },
    {
        path: '/console/form/configs/:_config',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/form/ConfigView.vue'),
        props: true
    },
    {
        path: '/console/forms',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/form/FormList.vue'),
        props: true
    },
    {
        path: '/console/forms/:_form',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/form/FormView.vue'),
        props: true
    },
    {
        path: '/console/send-emails',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/sendemail/SendEmail.vue'),
        props: true
    },
    {
        path: '/console/receptions',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/reception/ReceptionList.vue'),
        props: true
    },
    {
        path: '/console/receptions/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/reception/ReceptionView.vue'),
        props: true
    },
    {
        path: '/console/receptions/:_reception',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/reception/ReceptionView.vue'),
        props: true
    },
    {
        path: '/console/shop/products',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/product/ProductList.vue'),
        props: true
    },
    {
        path: '/console/shop/products/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/product/ProductView.vue'),
        props: true
    },
    {
        path: '/console/shop/products/:_product',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/product/ProductView.vue'),
        props: true
    },
    {
        path: '/console/shop/categories',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/category/CategoryList.vue'),
        props: true
    },
    {
        path: '/console/shop/brands',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/brand/BrandList.vue'),
        props: true
    },
    {
        path: '/console/shop/brands/:_brand',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/brand/BrandView.vue'),
        props: true
    },
    {
        path: '/console/shop/inquires',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/inquiry/InquiryList.vue'),
        props: true
    },
    {
        path: '/console/shop/inquires/:_inquiry',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/inquiry/InquiryView.vue'),
        props: true
    },
    {
        path: '/console/shop/reviews',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/review/ReviewList.vue'),
        props: true
    },
    {
        path: '/console/shop/expectations',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/expectation/ExpectationList.vue'),
        props: true
    },
    {
        path: '/console/shop/setting',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/setting/SettingView.vue'),
        props: true
    },

    {
        path: '/console/shop/purchases/order',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/purchase/OrderList.vue'),
        props: true
    },
    {
        path: '/console/shop/purchases/purchase',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/purchase/PurchaseList.vue'),
        props: true
    },
    {
        path: '/console/shop/purchases/shipping',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/purchase/ShippingList.vue'),
        props: true
    },
    {
        path: '/console/shop/purchases/cancel',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/purchase/CancelList.vue'),
        props: true
    },
    {
        path: '/console/shop/purchases/exchange',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/purchase/ExchangeList.vue'),
        props: true
    },
    {
        path: '/console/shop/purchases/return',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/purchase/ReturnList.vue'),
        props: true
    },
    {
        path: '/console/shop/purchases/complete',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/shop/purchase/CompleteList.vue'),
        props: true
    },
    {
        path: '/console/common/logos',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/logo/LogoList.vue'),
        props: true
    },
    {
        path: '/console/common/banners',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/banner/BannerList.vue'),
        props: true
    },
    {
        path: '/console/common/banners/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/banner/BannerView.vue'),
        props: true
    },
    {
        path: '/console/common/banners/:_banner',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/banner/BannerView.vue'),
        props: true
    },
    {
        path: '/console/common/popups',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/popup/PopupList.vue'),
        props: true
    },
    {
        path: '/console/center/notifications',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/center/notification/NotificationList.vue'),
        props: true
    },
    {
        path: '/console/center/notifications/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/center/notification/NotificationView.vue'),
        props: true
    },
    {
        path: '/console/center/notifications/:_notification',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/center/notification/NotificationView.vue'),
        props: true
    },
    {
        path: '/console/center/faqs',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/center/faq/FaqList.vue'),
        props: true
    },
    {
        path: '/console/center/faqs/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/center/faq/FaqView.vue'),
        props: true
    },
    {
        path: '/console/center/faqs/:_faq',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/center/faq/FaqView.vue'),
        props: true
    },
    {
        path: '/console/center/questions',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/center/question/QuestionList.vue'),
        props: true
    },
    {
        path: '/console/center/questions/:_question',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/center/question/QuestionView.vue'),
        props: true
    },
    {
        path: '/console/common/setting',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/common/setting/SettingView.vue'),
        props: true
    },
    {
        path: '/console/themes',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/theme/ThemeList.vue'),
        props: true
    },
    {
        path: '/console/themes/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/theme/ThemeInput.vue'),
        props: true
    },
    {
        path: '/console/themes/:_theme',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/theme/ThemeInput.vue'),
        props: true
    },

    {
        path: '/console/statistics/member',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/statistic/MemberStatistic.vue'),
        props: true
    },
    // 룰렛이벤트
    {
        path: '/console/roulette/setting',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/roulette/RouletteSetting.vue'),
        props: true
    },
    {
        path: '/console/roulette/setting/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/roulette/RouletteSettingView.vue'),
        props: true
    },
    {
        path: '/console/roulette/setting/:_setting',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/roulette/RouletteSettingView.vue'),
        props: true
    },
    {
        path: '/console/roulette/user',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/roulette/RouletteUserList.vue'),
        props: true
    },
    // 보물찾기 이벤트
    {
        path: '/console/hunt/setting',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/hunt/HuntSetting.vue'),
        props: true
    },
    {
        path: '/console/hunt/setting/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/hunt/HuntSettingView.vue'),
        props: true
    },
    {
        path: '/console/hunt/setting/:_setting',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/hunt/HuntSettingView.vue'),
        props: true
    },
    {
        path: '/console/hunt/user',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/hunt/HuntUserList.vue'),
        props: true
    },
    // 행운카드 이벤트
    {
        path: '/console/clover/setting',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/clover/CloverSetting.vue'),
        props: true
    },
    {
        path: '/console/clover/setting/create',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/clover/CloverSettingView.vue'),
        props: true
    },
    {
        path: '/console/clover/setting/:_setting',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/clover/CloverSettingView.vue'),
        props: true
    },
    {
        path: '/console/clover/user',
        component: () => import(/* webpackChunkName: "console-app" */ '../pages/console/clover/CloverUserList.vue'),
        props: true
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {

    let accessToken = sessionStorage.getItem("accessToken");

    axios.defaults.headers.common['Authorization'] = accessToken ? `Bearer ${accessToken}` : "";

    next();
});

export default router
